import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _OfficialBook } from "../../../core/services/dataBean/EntityCatalogVdos";
import { CompanyEditor } from "../cellEditor/Company/CompanyEditor";
import { BasicButton } from "../../theme/Component/BasicButton";



export const OfficialBook = () => {

    const book = useDataBean(_OfficialBook);
    const single = Singleton.getInstance();
    const [conpany, setCompany] = useState<number>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        book.instance.getOfficialBookCatalog(conpany).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )


    }

    const create = () => {
        book.setBean({
            IDCompany: book.bean.IDCompany
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        book.deleteItemVoid(book.bean.IDOfficialBook).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        book.instance.updateOfficialBook(book.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDOfficialBook', visible: true },
        { title: 'Compañia', property: 'CompanyName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Nombre del Reporte', property: 'HeaderReportName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Libros Oficiales de Contabilidad">
            <div className="row">
                <div className="col-md-6">
                    <CompanyEditor id={conpany} onchange={(e: any) => { setCompany(e) }}></CompanyEditor>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-search-line" clase="primary" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={book.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <CompanyEditor id={book.bean.IDCompany} onchange={(e) => { book.setBean({ ...book.bean, "IDCompany": e }) }}></CompanyEditor>
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={book.bean.Name} onChange={book.handleChange} />

                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={book.bean.Description} onChange={book.handleChange} />

                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {book.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}